'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DOMAIN = exports.DOMAIN = 'Domain';
var COVERAGE = exports.COVERAGE = 'Coverage';
var COVERAGECOLLECTION = exports.COVERAGECOLLECTION = COVERAGE + 'Collection';

var COVJSON_NS = 'http://covjson.org/def/core#';

var COVJSON_DATATYPE_TUPLE = exports.COVJSON_DATATYPE_TUPLE = COVJSON_NS + 'tuple';
var COVJSON_DATATYPE_POLYGON = exports.COVJSON_DATATYPE_POLYGON = COVJSON_NS + 'polygon';